//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileUpload from "@/pccomponents/FileUpload";
import AttachLoad from "@/pccomponents/AttachLoad";
  export default {
    name: "staffentrymapfile",
    data(){
        return{
          keyval:"",
          mapfileids :[],
          nosession:true
        }
    },
    components: {
      FileUpload,
      AttachLoad
    },
    props: {
      //业务数据
      record: {
        type: Object,
        default: () => ({})
      },
      //流程数据
      process: {
        type: Object,
        default: () => ({})
      },
      //规则绑定
      rules: {
        type: Object,
        default: () => ({})
      },
      //自定义的参数
      config: {
        type: Object,
        default: () => ({})
      },
      formName: {
        type: String,
        default: ''
      },
      //存放员工数据的原id
      originalId: {
        type: String,
        default: ''
      }
    },
    methods:{
      
    },
    computed:{
    }
  }




// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentrymapfile.vue